import { Crop } from '@crops';
import { Box } from '@mui/system';
import CropApi from 'api/CropApi';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, LineController } from 'chart.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { CommonDataState } from 'state/commonState';
import { GridArea } from 'components/common/GridArea';
import { AgGridReact } from 'ag-grid-react';
import { CropSchema } from 'constant/CropSchema';
import pannelState from 'state/rightPannelState';

type Props = {
  control: Control<Crop.FormData, any>;
};

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, LineController);

const AiTransitionTab = ({ control }: Props) => {
  const param = useWatch<Crop.FormData>({ control });
  const [isLoading, setIsLoading] = useState(true);
  const { cropYear, legend } = useRecoilValue(CommonDataState);
  const [common, setCommon] = useRecoilState(CommonDataState);
  const pannel = useRecoilValue(pannelState);
  const gridRef = useRef<AgGridReact>(null);

  const [selectType, setSelectType] = useState<'ai_area' | 'ai_count'>('ai_area');

  const [grid, setGrid] = useState([]);
  const [columnDefs, setColumnDefs] = useState({
    area: CropSchema.aiTransition.columnDefs,
    count: CropSchema.aiTransition.columnDefs,
  });
  const [chart, setChart] = useState({
    // TODO : 차트, 뭘 표시???
    // TODO : 2021, 2022 선택의 의미???
    datasets: [],
    labels: [],
  });

  useEffect(() => {
    // fetchData();
    if (pannel.status.aiTransition.isOpen) {
      makeColumn();
    }
  }, [pannel.status.aiTransition]);

  useEffect(() => {
    fetchData();
  }, [selectType]);

  const makeColumn = () => {
    const year = cropYear.map((i) => i.year).sort((a, b) => parseInt(a) - parseInt(b));
    console.log('select Type ', selectType);

    const areaColumn = [];
    const countColumn = [];
    year.forEach((y) => {
      areaColumn.push({
        headerName: y,
        field: `ai_area_${y}`,
        flex: 1,
        minWidth: 110,
        cellStyle: { textAlign: 'center' },
      });
      countColumn.push({
        headerName: y,
        field: `ai_count_${y}`,
        flex: 1,
        minWidth: 110,
        cellStyle: { textAlign: 'center' },
      });
    });

    setColumnDefs((prev) => ({
      area: [...prev.area, ...areaColumn],
      count: [...prev.count, ...countColumn],
    }));
  };

  const drawGrid = useCallback(
    (data) => {
      const year = cropYear.map((i) => i.year).sort((a, b) => parseInt(a) - parseInt(b));

      const cropList = [...new Set(data.map((i) => i.ai_cltv_cd))];
      console.log(cropList);

      const result = cropList.map((crop) => {
        const find = data.filter((item) => item.ai_cltv_cd === crop);
        const obj = find.map((i) => {
          return {
            ...i,
            [`${selectType}_${i.year}`]: i[selectType],
          };
        });

        return obj;
      });
      const da = result.map((row) => {
        return row.reduce((r, c) => Object.assign(r, c), {});
      });

      console.log(da);

      setGrid(da);
    },
    [selectType],
  );

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await CropApi.AiTransition({
        sggCd: param.sggCd,
        cltvCd: param.cltvCd,
        emdCd: param.emdCd,
      });

      const label = result
        .map((i) => i.ai_cltv_nm)
        .filter((value, index, self) => {
          // 중복제거
          return self.indexOf(value) === index;
        });

      const year = cropYear.map((i) => i.year).sort((a, b) => parseInt(a) - parseInt(b));
      const datasets = label.map((l) => ({ label: l, data: [] }));

      const years = [];
      year.forEach((y, index) => {
        const result_ = result.filter((i) => i.year === y);
        if (result_.length > 0) {
          years.push(result_);
        }
      });

      datasets.map((d, dataIndex) => {
        const result = [];
        years.map((item, index) => {
          result.push(item[dataIndex][selectType]);
        });
        const found = legend.filter((i) => i.cmmn_cd_val === d.label)[0];
        if (!found) return;
        Object.assign(d, {
          borderColor: `#${found.color}`,
          backgroundColor: `#${found.color}`,
          data: [...result],
        });
      });

      drawGrid(result);

      console.log(datasets);
      setChart({ labels: year, datasets: datasets });
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, [param, selectType]);

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <Box className="micMainArea">
      <div className="micChartWrap">
        <div className="micChartArea">
          <div className="micChart">
            <Chart
              type="line"
              data={chart}
              options={{
                scales: {
                  x: {
                    ticks: {
                      color: '#000000',
                      font: {
                        family: "'Roboto', sans-serif",
                        size: 12,
                      },
                    },
                  },
                  y: {
                    ticks: {
                      color: '#000000',
                      font: {
                        family: "'Roboto', sans-serif",
                        size: 12,
                      },
                    },
                  },
                },
                plugins: {
                  legend: {
                    position: 'bottom',
                    labels: {
                      boxWidth: 10,
                      boxHeight: 10,
                      padding: 16,
                      usePointStyle: true,
                      pointStyle: 'circle',
                      color: '#1E1D1F',
                      font: {
                        family: "'NotoSansKR', sans-serif",
                        size: 13,
                      },
                    },
                  },
                  datalabels: {
                    display: false,
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
      <Box className="cListTableWrap pt40">
        <Box className="cTableTopArea">
          <div className="cTableTopLeft">
            <div className="cTableTopTit">연도별 변화추이</div>
          </div>
        </Box>
        <div className="cTableEtcArea">
          <div className="cRadio">
            <input
              type="radio"
              id="ai_area"
              value="ai_area"
              checked={selectType === 'ai_area'}
              onChange={() => setSelectType('ai_area')}
            />
            <label htmlFor="ai_area">면적별</label>
          </div>
          <div className="cRadio">
            <input
              type="radio"
              id="ai_count"
              value="ai_count"
              checked={selectType === 'ai_count'}
              onChange={() => setSelectType('ai_count')}
            />
            <label htmlFor="ai_count">건수별</label>
          </div>
        </div>

        <Box className="cListTableArea">
          <GridArea
            gridRef={gridRef}
            rowData={grid}
            isPaging={false}
            columnDefs={selectType === 'ai_area' ? columnDefs.area : columnDefs.count}
            defaultColDef={{
              sortable: true,
              resizable: true,
            }}
            domLayout="autoHeight"
            onFirstDataRendered={onFirstDataRendered}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AiTransitionTab;
